"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var INTERACTION_EVENT_TYPES = ['scroll', 'mousemove', 'touchstart', 'keydown'];
var deferPlugin = function (_a) {
    var _b = _a.plugins, plugins = _b === void 0 ? [] : _b;
    var history = [];
    var startHook = function (type) {
        return function (_a) {
            var _b;
            var payload = _a.payload, instance = _a.instance;
            if ((_b = payload === null || payload === void 0 ? void 0 : payload.abort) === null || _b === void 0 ? void 0 : _b.reason)
                return;
            plugins.forEach(function (pluginName) {
                var _a;
                var _b, _c;
                if ((_b = instance.getState('plugins')[pluginName]) === null || _b === void 0 ? void 0 : _b.enabled)
                    return;
                if (((_c = payload.options) === null || _c === void 0 ? void 0 : _c.all) === false && !payload.options[pluginName])
                    return;
                history.push({
                    type: type,
                    payload: __assign(__assign({}, payload), { options: __assign(__assign({}, payload.options), (_a = { all: false }, _a[pluginName] = true, _a)) }),
                });
            });
        };
    };
    return {
        name: 'defer-plugin',
        loaded: function () { return true; },
        initializeEnd: function (_a) {
            var instance = _a.instance;
            if (typeof document === 'undefined' || typeof window === 'undefined')
                return;
            var enabledPlugins = false;
            var enablePluginsImmediate = function () {
                if (enabledPlugins)
                    return;
                instance.plugins.enable(plugins);
                enabledPlugins = true;
            };
            var enablePluginsOnEvent = function () {
                enablePluginsImmediate();
                INTERACTION_EVENT_TYPES.forEach(function (eventType) { return document.removeEventListener(eventType, enablePluginsOnEvent); });
            };
            INTERACTION_EVENT_TYPES.forEach(function (eventType) { return document.addEventListener(eventType, enablePluginsOnEvent); });
        },
        pageStart: startHook('page'),
        trackStart: startHook('track'),
        identifyStart: startHook('identify'),
        enablePlugin: function (_a) {
            var payload = _a.payload, instance = _a.instance;
            payload === null || payload === void 0 ? void 0 : payload.plugins.forEach(function (pluginToEnableName) {
                history = history.reduce(function (accumulator, _a) {
                    var type = _a.type, itemPayload = _a.payload;
                    if (!itemPayload.options[pluginToEnableName]) {
                        return accumulator.concat([{ type: type, payload: itemPayload }]);
                    }
                    setTimeout(function () {
                        switch (type) {
                            case 'page':
                                return instance[type](itemPayload.properties, itemPayload.options);
                            case 'track':
                                return instance[type](itemPayload.event, itemPayload.properties, itemPayload.options);
                            case 'identify':
                                return instance[type](itemPayload.userId, itemPayload.properties, itemPayload.options);
                            default:
                                return null;
                        }
                    }, 100);
                    return accumulator;
                }, []);
            });
        },
    };
};
exports.default = deferPlugin;
//# sourceMappingURL=index.js.map